module.exports = __webpack_public_path__ + "img/circle_num_1_red.f1946040.svg";